// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpaceInfo__container-a1b503 {
  padding-bottom: 10px;
}

.SpaceInfo__header-ec02b6 {
  display: flex;
  padding: 0 var(--space-profile-padding);
  margin-bottom: 22px;
}

.SpaceInfo__avatar-cabc14 {
  margin-inline-end: 10px;
}

.SpaceInfo__info-block-bf04c9 {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.SpaceInfo__name-b849ee {
  font: var(--font-title-8);
  letter-spacing: var(--font-spacing-title-8);
  color: var(--base-110);
  padding-inline-end: 32px;
  word-break: break-all;
}

.SpaceInfo__members-ad6619,
.SpaceInfo__category-e137f6 {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
}

.SpaceInfo__tag-b6a0af {
  margin-inline-start: 65px;
}`, "",{"version":3,"sources":["webpack://./src/main/Profile/SpaceProfile/SpaceInfo/SpaceInfo.styles.m.css"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,uCAAA;EACA,mBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;AACF;;AAEA;EACE,yBAAA;EACA,2CAAA;EACA,sBAAA;EACA,wBAAA;EACA,qBAAA;AACF;;AAEA;;EAEE,4BAAA;EACA,8CAAA;EACA,qBAAA;AACF;;AAEA;EACE,yBAAA;AACF","sourcesContent":[".container {\n  padding-bottom: 10px;\n}\n\n.header {\n  display: flex;\n  padding: 0 var(--space-profile-padding);\n  margin-bottom: 22px;\n}\n\n.avatar {\n  margin-inline-end: 10px;\n}\n\n.info-block {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n\n.name {\n  font: var(--font-title-8);\n  letter-spacing: var(--font-spacing-title-8);\n  color: var(--base-110);\n  padding-inline-end: 32px;\n  word-break: break-all;\n}\n\n.members,\n.category {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n}\n\n.tag {\n  margin-inline-start: 65px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SpaceInfo__container-a1b503`,
	"header": `SpaceInfo__header-ec02b6`,
	"avatar": `SpaceInfo__avatar-cabc14`,
	"info-block": `SpaceInfo__info-block-bf04c9`,
	"infoBlock": `SpaceInfo__info-block-bf04c9`,
	"name": `SpaceInfo__name-b849ee`,
	"members": `SpaceInfo__members-ad6619`,
	"category": `SpaceInfo__category-e137f6`,
	"tag": `SpaceInfo__tag-b6a0af`
};
module.exports = ___CSS_LOADER_EXPORT___;
